// src/components/doctor/ConsultTags.jsx
//
// The visibility tag every field in a consultation carries, so the doctor always
// knows what the patient will and will not see.

import React from 'react';

export const VisibleToPatient = () => <span className="consult-tag consult-tag--patient">Visible to patient</span>;
export const PrivateTag = ({ children = 'Never shown to patient' }) => <span className="consult-tag consult-tag--private">{children}</span>;
export const RequiredTag = () => <span className="consult-tag consult-tag--required">Required to sign</span>;
